module.exports = __webpack_public_path__ + "img/ai流行趋势图片.364f151d.png";